// extracted by mini-css-extract-plugin
export default {"container":"settlements_container__f9YT0","topWrapper":"settlements_topWrapper__5OQRZ","row":"settlements_row__sz7PP","mainWrapper":"settlements_mainWrapper__HyiCa"};